export default `query customerCart {
  customerCart{
    id
  }
}`
